import type { AnyPresentationOption, OptionsDocument } from 'paintscout'
import cloneDeep from 'lodash/cloneDeep'
import type { QuoteTemplateOption } from '../../../options'

export function setPresentationTemplate({
  template,
  presentationTemplate,
  options
}: {
  template: QuoteTemplateOption
  presentationTemplate: AnyPresentationOption
  options: OptionsDocument
}): AnyPresentationOption {
  // If no template, use default
  if (
    !template ||
    !template?.content?.presentationTemplate ||
    (template?.smartTemplate && !template?.content?.presentationTemplate?.templateCustom)
  ) {
    return presentationTemplate
  }
  // If template, either update it, or return the custom version for quote template
  return updateToLatestPresentation({ template: template.content.presentationTemplate, options })
}

function updateToLatestPresentation({
  template,
  options
}: {
  template: AnyPresentationOption
  options: OptionsDocument
}) {
  // Update to latest presentation unless Presentation has been customized to quote.
  if (template?.custom || !options.options?.presentationOptions?.values?.[template.key]) {
    return template
  }

  const updatedTemplate = cloneDeep(options.options.presentationOptions.values[template.key])
  return updatedTemplate
}
